<section>    
    <header class="row page-header">
        <div class="col-sm-12">
            
            <sp-breadcrumbs>
                <sp-breadcrumb [text]="'Portfolios'" [routerLink]="['/useraccount/admin/portfolios/']"></sp-breadcrumb>                
                <sp-breadcrumb [text]="portfolioBreadCrumbText" [routerLink]="['/useraccount/admin/portfolios/', workspaceId]"></sp-breadcrumb>                                                              
            </sp-breadcrumbs>
    
            <div class="row">
                <div class="col-sm-12">
                    <div class="row user-name-breadcrumb-container">                                                        
                        <div class="col-sm-6 title">
                            <a class="btn-back" [routerLink]="['/useraccount/admin/portfolios/', workspaceId]" [queryParams]="{ tabIndex: '2' }"></a>
                            <div class="user-name">{{linkFullName}}</div>
                        </div>
                        <div class="col-sm-6 d-flex justify-content-end joined-on">
                            Joined {{ joinedOn }}
                        </div>                            
                    </div>
                </div>
            </div>
        </div>
    </header>

    <main>
        <sp-workspace-edit-user-display
            *ngIf="((user$ | async) && (roles$ | async))"            
            [workspace]="workspace$ | async"
            [userProfile]="userProfile$ | async"
            [user]="user$ | async"
            [roles]="roles$ | async"            
            (cancel)="onCancel()"
            (save)="onSaveUser($event)">
        </sp-workspace-edit-user-display>
    </main>        
</section>